import { ApiError } from './shared-http.models';
import { ErrorMessages } from './http.errors';

export class SharedHttpService {
  public mapErrors(errors: Array<ApiError>): Array<string> {
    return errors.map((error) => this._mapError(error));
  }

  private _mapError(error: ApiError): string {
    return ErrorMessages.mapErrorMessage(error);
  }
}
